export default "__VITE_ASSET__DXXXViDI__"